import { render, staticRenderFns } from "./DeleteSingleProductConfirmModal.vue?vue&type=template&id=ac8f19b4"
import script from "./DeleteSingleProductConfirmModal.vue?vue&type=script&lang=js"
export * from "./DeleteSingleProductConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports